// Sohbet penceresi metinleri (baslik, mesaj kutusu yazisi): ziyaretci dili -> site varsayilani -> ilk dolu dil -> hazir ceviri.
// Panelde hic doldurulmamissa hazir ceviri doner; mevcut musterilerde pencere degismez.

function resolveChatText(settings, field, locale, fallback) {
    const s = settings || {};
    const content = ((s.webchat || {}).chatTexts || {}).languageContent || [];
    const pick = (code) => content.find((x) => x.languageCode === code && (x[field] || "").trim());
    const siteDefault = s.language && s.language.customerClientDefault;
    const entry = pick(locale) || pick(siteDefault) || content.find((x) => (x[field] || "").trim());
    return entry ? entry[field].trim() : fallback;
}

module.exports = { resolveChatText };



// WEBPACK FOOTER //
// ./src/utils/chatTexts.js